import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { indexOf, sumBy, startCase, toLower } from 'lodash';

import { Button, Card, CardBody, Col, Row, Input, Table, Tooltip } from 'reactstrap';
import Switch from 'react-switch';
import PieChart from '../../common/PieChart';
export default function RiskScore({ bugRisk, setBugRisk, riskError, loading }) {
  const [isOpenTooltip, setIsOpenTooltip] = useState({});
  const [showVariables, setShowVariables] = useState();

  const toggleTooltip = (e, id) => {
    // console.log('e: ', e);
    setIsOpenTooltip(e.type === 'mouseover' ? id : '');
    // setTimeout(() => {
    //   setIsOpenTooltip('');
    // }, 2500);
  };

  const handleSwitchToggle = (e, option) => {
    const options = [...bugRisk];
    const optionIndex = bugRisk.findIndex(item => {
      if (item.label === option.label) return true;
    });
    const others = bugRisk.filter(y => {
      return indexOf(y) !== optionIndex && y.active;
    });
    const othersSum = sumBy(others, risk => {
      return risk.value;
    });
    console.log('others sum', othersSum);
    const diff = othersSum + option.value - 100;

    // Add update value of option to 0 if set to disabled
    options[optionIndex] = {
      ...options[optionIndex],
      active: e === true ? 1 : 0,
      value: othersSum + option.value > 100 && !option.active ? option.value - diff : option.value
    };
    setBugRisk(options);
  };

  const changeRisk = (i, y, value) => {
    setBugRisk(prevState => {
      prevState[i].variables[y].score = parseInt(value);
      return [...prevState];
    });
  };

  const changeShare = (e, i) => {
    const num = e.target.value;
    // Add all other values of active matrices
    const others = bugRisk.filter(y => {
      return i !== bugRisk.indexOf(y) && y.active;
    });
    const othersSum = sumBy(others, risk => {
      return risk.value;
    });
    // Get max value for current filter
    if (num <= 100 - othersSum)
      setBugRisk(prevState => {
        prevState[i].value = parseInt(num);
        return [...prevState];
      });
    if (num < 0)
      setBugRisk(prevState => {
        prevState[i].value = 0;
        return [...prevState];
      });
  };

  const toggleVariables = (e, variables) => {
    e.preventDefault();
    variables === showVariables ? setShowVariables('') : setShowVariables(variables);
  };
  return (
    <>
      <Card className="mb-4">
        <CardBody>
          <Row>
            {' '}
            <Col md="6">
              <Table bordered className="risk-score-table">
                <thead>
                  <tr>
                    <th>Enabled</th>
                    <th>Category</th>
                    <th colSpan={2}>Risk Share (%)</th>
                  </tr>
                </thead>
                <tbody>
                  {bugRisk?.length ? (
                    bugRisk.map((item, i) => {
                      let cleanLabel =
                        item?.label === 'priority'
                          ? item?.label?.replace('priority', 'severity')
                          : item?.label?.replaceAll('_', ' ');
                      return (
                        <>
                          <tr key={i + item?.label + '-label-key'}>
                            <td>
                              <Switch
                                id={item?.label + '-switch'}
                                onChange={e => handleSwitchToggle(e, item)}
                                checked={item?.active === 1 ? true : false}
                                uncheckedIcon={false}
                                onColor="#617E71"
                                height={14}
                                width={28}
                              />
                            </td>
                            <td>
                              <div id={item.label + '-target'} className="d-flex">
                                <b>{startCase(toLower(cleanLabel))}</b>
                                {item?.description?.length ? (
                                  <>
                                    <FontAwesomeIcon
                                      icon="question-circle"
                                      className="fs--2 ml-1 text-primary"
                                      id="view-setting-tooltip"
                                    />
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              {item?.description?.length ? (
                                <Tooltip
                                  placement="top"
                                  isOpen={isOpenTooltip === item.label + '-target'}
                                  target={item.label + '-target'}
                                  autohide={true}
                                  toggle={e => toggleTooltip(e, item.label + '-target')}
                                >
                                  {item.description}
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                            </td>
                            <td>
                              <Input
                                size={10}
                                type="number"
                                value={bugRisk[i]?.value}
                                onChange={e => changeShare(e, i)}
                                style={{ width: '80px' }}
                                disabled={item?.active !== 1 ? true : false}
                              />
                            </td>
                            <td>
                              <Button
                                size="sm"
                                disabled={item?.active !== 1 ? true : false}
                                className="ml-2 btn-falcon-primary"
                                onClick={e => toggleVariables(e, item?.label)}
                              >
                                {showVariables === item?.label && item?.variables?.length ? 'Hide' : 'Edit'}
                              </Button>
                            </td>
                          </tr>
                          {showVariables === item?.label && item?.variables?.length ? (
                            <>
                              <tr>
                                <td colSpan={4}>
                                  <Table>
                                    {/* <thead className="card-header">
                                      <tr>
                                        <th>Name</th>
                                        <th>Risk Control</th>
                                      </tr>
                                    </thead> */}
                                    <tbody>
                                      {item?.variables?.map((sub, y) => {
                                        return (
                                          <tr key={y + sub?.label + '-variable-key'}>
                                            <td
                                              id={
                                                sub?.description
                                                  ?.substring(0, 9)
                                                  ?.trim()
                                                  ?.replaceAll(' ', '-')
                                                  ?.replaceAll("'", '') +
                                                '-' +
                                                y +
                                                '-target'
                                              }
                                              className="d-flex my-auto"
                                              style={{ width: '180px' }}
                                            >
                                              {sub?.label}
                                              {item?.description?.length ? (
                                                <>
                                                  <FontAwesomeIcon
                                                    icon="question-circle"
                                                    className="fs--2 ml-1 text-primary my-auto"
                                                    id="view-setting-tooltip"
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={
                                                      isOpenTooltip ===
                                                      sub.description
                                                        ?.substring(0, 9)
                                                        ?.trim()
                                                        ?.replaceAll(' ', '-')
                                                        ?.replaceAll("'", '') +
                                                        '-' +
                                                        y +
                                                        '-target'
                                                    }
                                                    target={
                                                      sub.description
                                                        ?.substring(0, 9)
                                                        ?.trim()
                                                        ?.replaceAll(' ', '-')
                                                        ?.replaceAll("'", '') +
                                                      '-' +
                                                      y +
                                                      '-target'
                                                    }
                                                    autohide={true}
                                                    toggle={e =>
                                                      toggleTooltip(
                                                        e,
                                                        sub.description
                                                          ?.substring(0, 9)
                                                          ?.trim()
                                                          ?.replaceAll(' ', '-')
                                                          ?.replaceAll("'", '') +
                                                          '-' +
                                                          y +
                                                          '-target'
                                                      )
                                                    }
                                                  >
                                                    {sub?.description}
                                                  </Tooltip>{' '}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                            <td className="w-75">
                                              <div className="d-flex">
                                                <Input
                                                  type="range"
                                                  className="mx-2 text-white custom-range"
                                                  value={sub?.score}
                                                  onChange={e => {
                                                    changeRisk(i, y, e.target?.value);
                                                  }}
                                                />
                                                <p className="my-auto">{sub?.score}/100</p>
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <></>
                  )}
                  <tr>
                    <td colSpan={4}>
                      {' '}
                      <small>Enabled categories must add up to 100%.</small>
                      <br />
                      {riskError?.length ? <small className="active">Error: {riskError}</small> : <></>}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col className="mt-2">
              <h3 className="text-center">Bug Risk Share</h3>

              {bugRisk?.filter(b => b?.active).length ? (
                <PieChart data={bugRisk?.filter(b => b?.active)} />
              ) : (
                <h5 className="text-center mt-8">No enabled categories</h5>
              )}
            </Col>
          </Row>{' '}
        </CardBody>
      </Card>
    </>
  );
}

RiskScore.propTypes = {
  bugRisk: PropTypes.array,
  riskError: PropTypes.string,
  setBugRisk: PropTypes.func,
  loading: PropTypes.bool
};
